export const isBoolean = (val: any) => typeof val === 'boolean'
